// export type TTableStructureType =
// 	| 'string'
// 	| 'text'
// 	| 'link'
// 	| 'number'
// 	| 'date'
// 	| 'datePeriod'
// 	| 'user'
// 	| 'status'
// 	| 'currency'
// 	| 'country'
// 	| 'boolean'
// 	| 'button'
// 	| 'buttons';

import { TTableStructureButton } from './types';

export enum ETableStructureType {
	ICON = 'icon',
	STRING = 'string',
	TEXT = 'text',
	LINK = 'link',
	NUMBER = 'number',
	DATE = 'date',
	DATE_TIME = 'dateTime',
	DATE_MONTH = 'dateMonth',
	DATE_PERIOD = 'datePeriod',
	DATE_RANGE = 'dateRange',
	AMOUNT = 'amount',
	STATUS = 'status',
	STATUS_NO_BG = 'statusNoBg',
	STATUS_ARRAY = 'statusArray',
	CURRENCY = 'currency',
	COUNTRY = 'country',
	COUNTRY_CODE = 'countryCode',
	COUNTRY_CODE_EU = 'countryCodeEu',
	COUNTRY_CODE_SUPPORTED = 'countryCodeSupported',
	COUNTRY_CODE_ARRAY = 'countryCodeArray',
	COUNTRY_NUMBER = 'countryNumber',
	BOOLEAN = 'boolean',
	BUTTONS = 'buttons',
	USER = 'user',
	USERS = 'users',
	MULTILINE_TEXT = 'multilineText',
	COPYABLE_TEXT = 'copyableText',
	CHECKBOX = 'checkbox',
	OPEN_IN_NEW_TAB = 'openInNewTab',
}

export enum ETableStructureAlign {
	CENTER = 'center',
	LEFT = 'left',
	RIGHT = 'right',
}

export type TTableStructureFilter = [string | null | number, string][];
export type TTableStructureColors = [string | null | number, string][];

export type TTableStructure<TSelector, TItem = any> = {
	name: string;
	selector: TSelector;
	value?: (item: TItem) => string | string[] | null;
	show: boolean;
	searchable?: boolean;
	searchInfoText?: string;
	sortable?: boolean;
	filterable?: boolean;
	filter?: TTableStructureFilter;
	separateFilter?: boolean;
	defaultFilterValue?: string;

	colors?: TTableStructureColors;
	colSpan: number;
	type: ETableStructureType;
	align: ETableStructureAlign;
	currency?: (item: TItem) => string;
	breakdown?: (item: TItem) => JSX.Element | null;
	noName?: boolean;
	buttons?: TTableStructureButton[];
	buttonFilter?: (item: TItem) => TTableStructureButton[];
	link?: (item: TItem) => string | null;
	tooltip?: string;
};

export type THandleAction = (id: number, typeOfDialog: string) => void;

export type TShowButtons = {
	[key: string]: boolean;
};
